import { render, staticRenderFns } from "./ManifestCardView.vue?vue&type=template&id=e48f8178&scoped=true&"
import script from "./ManifestCardView.vue?vue&type=script&lang=js&"
export * from "./ManifestCardView.vue?vue&type=script&lang=js&"
import style0 from "./ManifestCardView.vue?vue&type=style&index=0&id=e48f8178&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48f8178",
  null
  
)

export default component.exports